import { useEffect } from 'react'
import { Content, Background, Panel, PageHeader, Spinner } from '@/presentation/components'
import BrokerImportOrderFile from './components/importOrderFile'
import ImportResult from './components/importResults'
import history from '@/services/history'
import BrokerOtimo from '@/utils/broker/otimo'
import { BROKER_OPTIONS } from '@/utils/constants'
import { useSendFile } from './hooks/useSendFile'
import { useOrder } from './hooks/useOrder'

const BrokerOrder = ({ location }) => {
  const broker = location.state?.broker
  const brokerData = chooseBroker(broker)

  const { sendFileRequest, sendFileState, response, setResponse } = useSendFile({ brokerData })
  const { fetchLastOrderRequest, fetchLastOrderState, redoOrderRequest, redoOrderState } = useOrder({ brokerData })

  const lastOrder = fetchLastOrderState.response?.data?.lastOrder
  const isLoading = sendFileState.loading || fetchLastOrderState.loading || redoOrderState.loading

  function chooseBroker(brokerName) {
    switch (brokerName) {
      case BROKER_OPTIONS.OTIMO:
        return BrokerOtimo
      default:
        break
    }
  }

  useEffect(() => {
    !location.state?.broker ? history.push('/') : fetchLastOrderRequest()
    // eslint-disable-next-line
  }, [])

  const render = () => {
    if (!response?.base64)
      return (
        <BrokerImportOrderFile
          brokerData={brokerData}
          lastOrder={lastOrder}
          sendFile={sendFileRequest}
          redoOrder={redoOrderRequest}
        />
      )
    return <ImportResult response={response} goBack={() => setResponse(null)} sendFile={sendFileRequest} />
  }

  return (
    <Background>
      <Content>
        <Panel
          style={{
            minHeight: '700px',
            display: 'flex',
            flexDirection: 'column',
          }}
          noPadding
        >
          <PageHeader>Pedido de Recarga Broker {brokerData?.brokerName}</PageHeader>
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: '1',
              }}
            >
              <Spinner />
            </div>
          ) : (
            render()
          )}
        </Panel>
      </Content>
    </Background>
  )
}

export default BrokerOrder
